import React, { useEffect, useState } from "react";
  import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import {API_URL} from "../utils/api";
import axios  from "axios";

const AddWorkGalleryLayer = () => {
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState(null);
   const [title, setTitle] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [attachmenttype, setAttType] = useState("");
  const [ytbUrl, setYtbUrl] = useState("");

  const [titleErr, setTitleErr] = useState(false);
  const [thumbnailErr, setThumbnailErr] = useState(false);
  const [ytbErr, setYtbErr] = useState(false);
  const [atttypeErr, setAttTypeErr] = useState(false);
 
  const handleRemoveImage = () => {
    setImagePreview(null);
    setThumbnailErr(true);
  };
 
 
  const handleFileChange = async(e) => {
    if (e.target.files && e.target.files.length > 0) {
      var targetFile = e.target.files[0];
      const src = URL.createObjectURL(targetFile);
      setThumbnail(targetFile);
      setImagePreview(src);
      setThumbnailErr(false);
 
    }
  };

 
  const handleSubmit = () => {
    
    if(title != "" && attachmenttype != "" && ((attachmenttype == "image" && thumbnail != "") || (attachmenttype == "youtube" && ytbUrl != "")  )){
    var formData = {
      title : title,
      type: attachmenttype,
      image : (attachmenttype == "image")?thumbnail:"",
      ytburl:ytbUrl
    };
    console.log(formData);
    let headrs ={};
    if(attachmenttype == "image"){
        headrs = {
            "content-type": "multipart/form-data"
        };
    }

    axios.post(process.env.REACT_APP_API_BASE_URL+"work-gallery-add", { ...formData }, {
      headers: headrs
    })
      .then((res) => {
          console.log(res.data);
          // return false;
        if(res.data.status === true){
            toast.success('Record added sucessfully!!');
            setTimeout(() => {
              navigate('/'+JSON.parse(localStorage.getItem('activeUser')).user_type+'/work-gallery-list');
            }, 2000);
        }
        else{
          alert("something went wrong...")
        }
      })
      .catch(err => {
        console.error(err);
        alert(err);
      });

    } else {
     
        if(title == ""){
            setTitleErr(true);
        }
        if(attachmenttype == "image" && thumbnail == ""){
            setThumbnailErr(true);
        } else {
            setThumbnailErr(false);
        }
        if(attachmenttype == "youtube" && ytbUrl == ""){
            setYtbErr(true);
        } else{
            setYtbErr(false);
        }
  
    }
  }

  

  return (
    <div className='row gy-4'>
      <div className='col-lg-12'>
        <div className='card mt-24'>
          <div className='card-header border-bottom'>
            <h6 className='text-xl mb-0'>Add Gallery</h6>
          </div>
          <ToastContainer></ToastContainer>
          <div className='card-body p-24'>
            
              <div>
                <label
                  className='form-label fw-bold text-neutral-900'
                  htmlFor='title'
                >
                  Title:{" "}
                </label>
                <input
                  onChange={(e) => {
                    setTitle(e.target.value)
                    setTitleErr(true);
                    if(e.target.value !== ""){
                      setTitleErr(false);
                    }
                  
                  }}
                  type='text'
                  className={titleErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
                   id='title'
                  placeholder='Enter Title'
                />
                 {titleErr && (
                        <span className="error-message">
                            {'Title is mandatory'}
                        </span>
                    )} 
              </div>
              
              <div>
                <label
                  className='form-label fw-bold text-neutral-900'
                  htmlFor='type'
                >
                  Gallery Type:{" "}
                </label>
                <select
                  onChange={(e) => {
                    setAttType(e.target.value)
                    setAttTypeErr(true);
                    if(e.target.value !== ""){
                        setAttTypeErr(false);
                    }
                  
                  }}
                   className={atttypeErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
                   id='type' 
                >
<option value={""}>Select Attachment Type</option>
<option value={"image"}>Image</option>
<option value={"youtube"}>Youtube Video</option>
                    </select>
                 {atttypeErr && (
                        <span className="error-message">
                            {'Attachment type is mandatory'}
                        </span>
                    )} 
              </div>
              
              
              {attachmenttype === "image" && (<div>
                <label className='form-label fw-bold text-neutral-900'>
                  Upload Before Thumbnail
                </label>
                <div className='upload-image-wrapper'>
                  {imagePreview ? (
                    <div className='uploaded-img position-relative h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50'>
                      <button
                        type='button'
                        className='uploaded-img__remove position-absolute top-0 end-0 z-1 text-2xxl line-height-1 me-8 mt-8 d-flex bg-danger-600 w-40-px h-40-px justify-content-center align-items-center rounded-circle'
                        onClick={handleRemoveImage}
                      >
                        <iconify-icon
                          icon='radix-icons:cross-2'
                          className='text-2xl text-white'
                        ></iconify-icon>
                      </button>
                      <img
                        id='uploaded-img__preview'
                        className='w-100 h-100 object-fit-cover'
                        src={imagePreview}
                        alt='Uploaded'
                      />
                    </div>
                  ) : (
                    <label
                      className='upload-file h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center flex-column justify-content-center gap-1'
                      htmlFor='upload-file'
                    >
                      <iconify-icon
                        icon='solar:camera-outline'
                        className='text-xl text-secondary-light'
                      ></iconify-icon>
                      <span className='fw-semibold text-secondary-light'>
                        Upload
                      </span>
                      <input
                        id='upload-file'
                        type='file'
                        hidden
                        onChange={handleFileChange}
                      />
                    </label>
                  )}
                  {thumbnailErr && (
                        <span className="error-message">
                            {'Attachment is mandatory'}
                        </span>
                    )}
                </div>
              </div>)}
              
               {attachmenttype === "youtube" && (
                 <div>
                 <label
                   className='form-label fw-bold text-neutral-900'
                   htmlFor='ytburl'
                 >
                   Youtube Url:{" "}
                 </label>
                 <input
                   onChange={(e) => {
                    setYtbUrl(e.target.value)
                    setYtbErr(true);
                     if(e.target.value !== ""){
                        setYtbErr(false);
                     }
                   
                   }}
                   type='url'
                   className={ytbErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
                    id='ytburl'
                   placeholder='Enter Youtube URL'
                 />
                  {ytbErr && (
                         <span className="error-message">
                             {'Youtube Url is mandatory'}
                         </span>
                     )} 
               </div>
              )}



              <br></br>
              <button onClick={() => handleSubmit()} className='btn btn-primary-600 radius-8'>
                Submit
              </button>
            
          </div>
        </div>
      </div>
      {/* Sidebar Start */}
    </div>
  );
};

export default AddWorkGalleryLayer;
